import { useContext } from "react";
import { useAuth } from "../../auth/useAuth";
import { Domains } from "../../data/Domains";
import { HttpMethods } from "../../data/HttpMethods";
import { NotificationTypes } from "../../data/NotificationTypes";
import { TokenDto } from "../../dtos/TokenDto";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { fetchData, getHttpOptions } from "../../utils/http.util";


export const useManageQrCodes = ( ): {

    getTokens( domain: Domains ): Promise<TokenDto[]>
    , updateToken( domain: Domains, isThirdParty?: boolean ): Promise<string | undefined>
    

} => {

    const { functionKey, setNotificationText, setNotificationType } = useContext( VillageConsoleContext );
    const { getIdToken } = useAuth( );


    const getTokens = async ( domain: Domains ): Promise<TokenDto[]> => {

        const query = `${process.env.REACT_APP_API_URL}/tokens?domain=${domain}`;
        const idToken: string = await getIdToken( );
        const options = getHttpOptions ( idToken, functionKey!, HttpMethods.Get );

        const response = await fetchData( options, query  );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( `Error fetching tokens for ${domain}` );

            return [];

        }

        return await response.response?.json( );

    }


    const updateToken = async ( domain: Domains, isThirdParty?: boolean ): Promise<string | undefined> => {

        let query: string;

        if( domain === Domains.Bma ){

            query = `${process.env.REACT_APP_API_URL}/new-token?domain=${domain}&isThirdParty=${isThirdParty}`;

        } else {
            
            query = `${process.env.REACT_APP_API_URL}/new-token?domain=${domain}`;

        }
        
        const idToken: string = await getIdToken( );
        const options = getHttpOptions ( idToken, functionKey!, HttpMethods.Post );

        const response = await fetchData( options, query  );

        if ( response.statusCode !== 200 ) {

            setNotificationType( NotificationTypes.Error );
            setNotificationText( `Error updating QR code for ${domain}` );
            return undefined;

        }

        setNotificationType( NotificationTypes.Success );
        setNotificationText( `QR code successfully updated for ${domain}` );

        return await response.response?.text( );

    };

    return {
     
        getTokens
        , updateToken

    };

}